import { toast } from "react-toastify";

export function HandleErrors(err: any): void {
  try {    
    if (err.response) {
      if (err.response.status === 401 ) {
        return;
      }

      if (err.response.data.message) {
        toast.error(err.response.data.message);
        return;

      } else {
        throw err;
      }

    } else {
      throw err;
    }
  } catch (error) {
    console.error(error);
    toast.error("خطایی پیش آمده، لطفا دوباره تلاش کنید.");
  }
}
